import type { PersonDetailed, UpdatePersonRequest } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

export function updatePersonDetails(personId: string, formData: UpdatePersonRequest): Promise<PersonDetailed> {
  return requestApiJsonOrThrow<PersonDetailed>(`admin/people/${personId}`, {
    method: 'PATCH',
    body: formData,
  })
}
